var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.10441 4.1732V9.82595L7.00008 12.6526L11.8958 9.82595V4.1732L7.00008 1.34654L2.10441 4.1732ZM13.0624 10.1632L13.0573 10.2401C13.0336 10.4181 12.9287 10.5773 12.7708 10.6685L7.29175 13.8312C7.1338 13.9224 6.94387 13.9338 6.77791 13.8654L6.70841 13.8312L1.22941 10.6685C1.07142 10.5773 0.96655 10.4181 0.942871 10.2401L0.937744 10.1632V3.83653C0.937786 3.62818 1.04897 3.43543 1.22941 3.33124L6.70841 0.168484C6.8889 0.0642814 7.11126 0.0642814 7.29175 0.168484L12.7708 3.33124C12.9512 3.43543 13.0624 3.62818 13.0624 3.83653V10.1632Z",
    fill: "#634EE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48544 6.3502L6.90877 7.36438L1.5229 4.30198L2.09956 3.2878L7.48544 6.3502Z",
    fill: "#634EE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51474 6.3502L7.0914 7.36438L12.4773 4.30198L11.9006 3.2878L6.51474 6.3502Z",
    fill: "#634EE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58341 13.4895H6.41675L6.41675 6.30719H7.58341L7.58341 13.4895Z",
    fill: "#634EE6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.5ad381cc1555245e65417aa690b1a66d.svg";
export { ForwardRef as ReactComponent };